function removeDesktopFilterBelow767() {
  if (window.innerWidth < 767) {
    const el = document.querySelector('#block_desktop-filter');
    if (el) {
      el.remove();
    }
  }
}

document.addEventListener('DOMContentLoaded', removeDesktopFilterBelow767);
window.addEventListener('resize', removeDesktopFilterBelow767);
function waitForSliderElements(callback, retry = 10, interval = 200) {
  let attempts = 0;
  const check = setInterval(() => {
    const gte = document.getElementById('Filter-Price-GTE');
    const lte = document.getElementById('Filter-Price-LTE');
    const slider = document.getElementById('price-slider-range');

    if (gte && lte && slider) {
      clearInterval(check);
      callback();
    } else if (attempts >= retry) {
      clearInterval(check);
      console.warn('Price slider elements not found.');
    }
    attempts++;
  }, interval);
}

function PriceRangeprogressbar() {
  const slider = document.getElementById('price-slider-range');
  if (slider.classList.contains('ui-slider') && typeof $(slider).slider === 'function') {
    $(slider).slider('destroy');
  }

  const gteInput = document.getElementById('Filter-Price-GTE');
  const lteInput = document.getElementById('Filter-Price-LTE');

  const min_val = Math.round(parseFloat(gteInput?.getAttribute('data-min')));
  const max_val = Math.round(parseFloat(lteInput?.getAttribute('data-max')));

  const min = Math.round(parseFloat(lteInput?.getAttribute('data-min')));
  const max = Math.round(parseFloat(gteInput?.getAttribute('data-max')));

  $(slider).slider({
    range: true,
    min: min_val,
    max: max_val,
    values: [min, max],
    change: function (event, ui) {
      const minValue = ui.values[0].toFixed(2); // e.g., "25.00"
      const maxValue = ui.values[1].toFixed(2); // e.g., "100.00"

      gteInput.value = minValue;
      gteInput.setAttribute('data-max', maxValue);

      lteInput.value = maxValue;
      lteInput.setAttribute('data-min', minValue);

      const priceInputEvent = new Event('input', { bubbles: true, cancelable: true });
      lteInput.dispatchEvent(priceInputEvent);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    waitForSliderElements(PriceRangeprogressbar);
  }, 500);
});










class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
           setTimeout(() => {
            waitForSliderElements(PriceRangeprogressbar);
          }, 100);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
         filteView()
       
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    
    setTimeout(function(){
      waitForSliderElements(PriceRangeprogressbar);  
    },1000);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    // Format value to 2 decimals if value is not empty
    if (maxInput.value)
      minInput.setAttribute('data-max', parseFloat(maxInput.value).toFixed(2));
    if (minInput.value)
      maxInput.setAttribute('data-min', parseFloat(minInput.value).toFixed(2));

    if (minInput.value === '')
      maxInput.setAttribute('data-min', '0.00');

    if (maxInput.value === '')
      minInput.setAttribute('data-max', parseFloat(maxInput.getAttribute('data-max') || 0).toFixed(2));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min && input.value !== '') {
      console.log('1');
      input.value = min.toFixed(2);
    }

    if (value > max && input.value !== '') {
      console.log('2');
      input.value = max.toFixed(2);
    }

    if (input.value === '' && min === 0 && max === 0) {
      console.log('3');
      input.value = min.toFixed(2);
    }

    if (input.value === '' && min !== 0) {
      console.log('4');
      input.value = max.toFixed(2);
    }

    setTimeout(function () {
      waitForSliderElements(PriceRangeprogressbar);
    }, 1000);
  }
}





customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  
  }
}

customElements.define('facet-remove', FacetRemove);



//collection mobile sort by
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-mobile-facets__close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      document.querySelectorAll('.mobile-facets__disclosure.disclosure-has-popup').forEach(el => {
        el.classList.remove('menu-opening');
        const inner = el.querySelector('.mobile-facets__inner');
        inner?.addEventListener('transitionend', function handler() {
          el.removeAttribute('open');
  
          document.body.classList.remove('overflow-hidden-mobile');
          inner.removeEventListener('transitionend', handler);
        });
      });
    });
  });
});




document.addEventListener('DOMContentLoaded', function () {
  //sort by filter
  const sortItems = document.querySelectorAll('.custom-sort-item');
  const sortSelect = document.getElementById('SortBy');
  const form = document.getElementById('FacetSortForm');
  const applyBtn = document.querySelector('.custom-sort-apply-btn');
  if (!sortItems.length || !sortSelect || !form) {
    return;
  }
  sortItems.forEach(item => {
    item.addEventListener('click', function () {
      const selectedValue = item.getAttribute('data-value');
      if (selectedValue) {
        sortSelect.value = selectedValue;
      }
      // sortSelect.value = selectedValue;
      // form.submit();
    });
  });
   // Submit form on Apply button click
   if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      form.submit();
    });
  }

  // filter close click mobile
  document.querySelector('.custom-mobile-facets__close')?.addEventListener('click', () => {
    document.querySelectorAll('.mobile-facets__disclosure.disclosure-has-popup').forEach(el => {
      el.classList.remove('menu-opening');
      const inner = el.querySelector('.mobile-facets__inner');
      inner?.addEventListener('transitionend', function handler() {
        el.removeAttribute('open');
        document.body.classList.remove('overflow-hidden-mobile');
        inner.removeEventListener('transitionend', handler);
      });
    });
  });



document.querySelectorAll('.block_advanced-filter-data-inner').forEach(inner => {
  inner.addEventListener('click', (event) => {
    const parent = event.target.closest('.block_advanced-filter-data');
    if (parent) {
      parent.classList.toggle('active');
    }
  });
});
  
});

  function toggleFilterBlock(headerEl) {
    const wrapper = headerEl.closest(".block_filter-wrapper");
    const content = wrapper.querySelector(".block_filter-content");
    const plus = headerEl.querySelector(".block__svg--plus");
    const minus = headerEl.querySelector(".block__svg--minus");

    const isOpen = wrapper.classList.toggle("open");

    content.style.display = isOpen ? "block" : "none";
    plus.style.display = isOpen ? "none" : "block";
    minus.style.display = isOpen ? "block" : "none";
  }




  function block_filterCollections(inputEl) {
    const wrapper = inputEl.closest(".block_filter-wrapper");
    const content = wrapper.querySelector(".block_filter-content");
    const items = content.querySelectorAll(".block_filter-item");
    const showLimit = 6;
    const filter = inputEl.value.trim().toUpperCase();
    const showMoreBtn = wrapper.querySelector(".block_show-more-btn");

    let visibleCount = 0;

    items.forEach((item) => {
      const text = item.textContent.toUpperCase();
      const matches = filter === "" || text.includes(filter);
      item.style.display = matches ? "" : "none";
      if (matches) visibleCount++;
    });

    if (filter !== "") {
      if (showMoreBtn) showMoreBtn.style.display = "none";
    } else {
      if (showMoreBtn) {
        showMoreBtn.style.display = "inline-block";
        block_toggleShowMore(showMoreBtn, true);
      }

      items.forEach((item, idx) => {
        item.style.display = idx < showLimit ? "" : "none";
      });
    }
  }

  function block_toggleShowMore(button, forceCollapse = false) {
    const wrapper = button.closest(".block_filter-wrapper");
    const items = wrapper.querySelectorAll(".block_filter-item");
    const showLimit = 6;
    const isExpanded = button.classList.contains("expanded");
    const collapse = forceCollapse || isExpanded;

    const showLabel = button.querySelector(".block_show-more-label");
    const hideLabel = button.querySelector(".block_show-less-label");

    items.forEach((item, idx) => {
      if (idx >= showLimit) item.style.display = collapse ? "none" : "";
    });

    if (collapse) {
      showLabel.classList.remove("hidden");
      hideLabel.classList.add("hidden");
      button.classList.remove("expanded");
    } else {
      showLabel.classList.add("hidden");
      hideLabel.classList.remove("hidden");
      button.classList.add("expanded");
    }
  }





  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".block_filter-wrapper").forEach(wrapper => {
      wrapper.classList.add("open");
      wrapper.querySelector(".block_filter-content").style.display = "block";
      wrapper.querySelector(".block__svg--plus").style.display = "none";
      wrapper.querySelector(".block__svg--minus").style.display = "block";
    });
  });


// Mobile-filter-buttons
  function showAdvancedFilter() {
    document.querySelector('.block_mobile_adbanced_filter')?.classList.remove('hidden');
    document.querySelector('.block_mobile_basic_filter')?.classList.add('hidden');

    document.querySelector('.block_filter-basic')?.classList.remove('hidden');
    document.querySelector('.block_filter-advanced')?.classList.add('hidden');
  }

  function showBasicFilter() {
    document.querySelector('.block_mobile_basic_filter')?.classList.remove('hidden');
    document.querySelector('.block_mobile_adbanced_filter')?.classList.add('hidden');

    document.querySelector('.block_filter-advanced')?.classList.remove('hidden');
    document.querySelector('.block_filter-basic')?.classList.add('hidden');
  }



